import { fromJS } from 'immutable'
import {
  TIMESHEET_REDIRECT_SET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TIMESHEET_REDIRECT_SET:
      return state
        .set('isFetching', true)
        .set('redirect', fromJS(action.payload))
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-redirect-reducer.js